import React, { ReactNode } from 'react';

import styles from './Folded2025Title.module.scss';

interface Folded2025TitleProps {
	icon: ReactNode;
	children: ReactNode;
	className?: string;
}

const Folded2025Title = ({
	icon,
	children,
	className,
}: Folded2025TitleProps): JSX.Element => {
	return (
		<div className={`${styles.title} ${className || ''}`}>
			<div className={styles.icon}>{icon}</div>
			{children}
		</div>
	);
};

export default Folded2025Title;
